/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IntegrationEventPccPatientLeadsInnerOccupanciesInnerBed } from './IntegrationEventPccPatientLeadsInnerOccupanciesInnerBed';
import {
    IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedFromJSON,
    IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedFromJSONTyped,
    IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedToJSON,
} from './IntegrationEventPccPatientLeadsInnerOccupanciesInnerBed';

/**
 * 
 * @export
 * @interface IntegrationEventPccPatientLeadsInnerOccupanciesInner
 */
export interface IntegrationEventPccPatientLeadsInnerOccupanciesInner {
    /**
     * 
     * @type {string}
     * @memberof IntegrationEventPccPatientLeadsInnerOccupanciesInner
     */
    occupancy_type?: string;
    /**
     * 
     * @type {IntegrationEventPccPatientLeadsInnerOccupanciesInnerBed}
     * @memberof IntegrationEventPccPatientLeadsInnerOccupanciesInner
     */
    bed?: IntegrationEventPccPatientLeadsInnerOccupanciesInnerBed;
}

/**
 * Check if a given object implements the IntegrationEventPccPatientLeadsInnerOccupanciesInner interface.
 */
export function instanceOfIntegrationEventPccPatientLeadsInnerOccupanciesInner(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function IntegrationEventPccPatientLeadsInnerOccupanciesInnerFromJSON(json: any): IntegrationEventPccPatientLeadsInnerOccupanciesInner {
    return IntegrationEventPccPatientLeadsInnerOccupanciesInnerFromJSONTyped(json, false);
}

export function IntegrationEventPccPatientLeadsInnerOccupanciesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): IntegrationEventPccPatientLeadsInnerOccupanciesInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'occupancy_type': !exists(json, 'occupancy_type') ? undefined : json['occupancy_type'],
        'bed': !exists(json, 'bed') ? undefined : IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedFromJSON(json['bed']),
    };
}

export function IntegrationEventPccPatientLeadsInnerOccupanciesInnerToJSON(value?: IntegrationEventPccPatientLeadsInnerOccupanciesInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'occupancy_type': value.occupancy_type,
        'bed': IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedToJSON(value.bed),
    };
}

